// src/features/boe/components/programs/Program0700.jsx
import React from "react";
import { ProgramBudget } from "../../../../budget/model/program/ProgramBudget.jsx";

export const PROGRAM_0700_CONFIG = {
  fullName: "HISTORY & SOCIAL SCIENCES",
  docId: "0700",

  fieldDefs: [
    // Positions (FTE)
    {
      key: "positionsAdmin",
      label: "Positions – Administrative",
      valueType: "count",
      sources: [{ block: "Positions", key: "Administrative" }],
      group: "positions",
      defaultVisible: false,
    },
    {
      key: "positionsTeachers",
      label: "Positions – Teachers",
      valueType: "count",
      sources: [{ block: "Positions", key: "Teachers" }],
      group: "positions",
      defaultVisible: false,
    },

    // Salaries
    {
      key: "salariesAdmin",
      label: "Salaries – Administrative",
      valueType: "currency",
      sources: [{ block: "Salaries", key: "Administrative" }],
      group: "salaries",
      defaultVisible: false,
    },
    {
      key: "salariesTeachers",
      label: "Salaries – Teachers",
      valueType: "currency",
      sources: [{ block: "Salaries", key: "Teachers" }],
      group: "salaries",
      defaultVisible: false,
    },

    // Purchased Services
    {
      key: "fieldTrips",
      label: "Field Trips",
      valueType: "currency",
      sources: [{ block: "Purchased Services", key: "Field Trips" }],
      group: "services",
      defaultVisible: false,
    },
    {
      key: "resourceSpeakers",
      label: "Resource Speakers",
      valueType: "currency",
      sources: [{ block: "Purchased Services", key: "Resource Speakers" }],
      group: "services",
      defaultVisible: false,
    },

    // Supplies / Materials
    {
      key: "instructionalMaterials",
      label: "Instructional Materials",
      valueType: "currency",
      sources: [
        {
          block: "Supplies / Materials",
          key: "Instructional Materials",
        },
      ],
      group: "materials",
      defaultVisible: false,
    },
    {
      key: "technologySoftware",
      label: "Technology Software",
      valueType: "currency",
      sources: [
        {
          block: "Supplies / Materials",
          key: "Technology Software",
        },
      ],
      group: "materials",
      defaultVisible: false,
    },

    // Other
    {
      key: "duesFees",
      label: "Dues & Fees",
      valueType: "currency",
      sources: [{ block: "Other", key: "Dues and Fees" }],
      group: "other",
      defaultVisible: false,
    },
  ],

  tables: [
    {
      id: "approvedMain",
      title: "0700 HISTORY & SOCIAL SCIENCES – Approved",
      sectionKey: "Approved",
      fields: [
        "positionsAdmin",
        "positionsTeachers",
        "salariesAdmin",
        "salariesTeachers",
        "fieldTrips",
        "resourceSpeakers",
        "instructionalMaterials",
        "technologySoftware",
        "duesFees",
      ],
      columnStyles: {
        year: { width: "100px", minWidth: "100px" },

        // Positions
        positionsAdmin: { minWidth: "130px" },
        positionsTeachers: { minWidth: "150px" },

        // Salaries
        salariesAdmin: { minWidth: "130px" },
        salariesTeachers: { minWidth: "150px" },

        // Services
        fieldTrips: { minWidth: "120px" },
        resourceSpeakers: { minWidth: "150px" },

        // Materials / Other
        instructionalMaterials: { minWidth: "170px" },
        technologySoftware: { minWidth: "160px" },
        duesFees: { minWidth: "100px" },
      },
    },
    {
      id: "actualMain",
      title: "0700 HISTORY & SOCIAL SCIENCES – Actual",
      sectionKey: "Actual",
      fields: [
        "positionsAdmin",
        "positionsTeachers",
        "salariesAdmin",
        "salariesTeachers",
        "fieldTrips",
        "resourceSpeakers",
        "instructionalMaterials",
        "technologySoftware",
        "duesFees",
      ],
      columnStyles: {
        year: { width: "100px", minWidth: "100px" },

        // Positions
        positionsAdmin: { minWidth: "130px" },
        positionsTeachers: { minWidth: "150px" },

        // Salaries
        salariesAdmin: { minWidth: "130px" },
        salariesTeachers: { minWidth: "150px" },

        // Services
        fieldTrips: { minWidth: "120px" },
        resourceSpeakers: { minWidth: "150px" },

        // Materials / Other
        instructionalMaterials: { minWidth: "170px" },
        technologySoftware: { minWidth: "160px" },
        duesFees: { minWidth: "100px" },
      },
    },
  ],

  inflationSumFields: null,
};

export function Program0700(props) {
  return (
    <ProgramBudget programId="0700" config={PROGRAM_0700_CONFIG} {...props} />
  );
}
